"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "pathfinders_cont"
};
const _hoisted_2 = {
    key: 0,
    class: "track track-background-venus"
};
const _hoisted_3 = { class: "track-venus" };
const _hoisted_4 = { class: "track track-background-earth" };
const _hoisted_5 = { class: "track-earth" };
const _hoisted_6 = { class: "track track-background-mars" };
const _hoisted_7 = { class: "track-mars" };
const _hoisted_8 = { class: "track track-background-jovian" };
const _hoisted_9 = { class: "track-jovian" };
const _hoisted_10 = {
    key: 1,
    class: "track track-background-moon"
};
const _hoisted_11 = { class: "track-moon" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PlanetaryTrack = (0, vue_1.resolveComponent)("PlanetaryTrack");
    return (_ctx.tracks)
        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
            (_ctx.tracks.venus >= 0)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
                    _cache[0] || (_cache[0] = (0, vue_1.createElementVNode)("div", { class: "track-tag track-tag-venus" }, null, -1)),
                    (0, vue_1.createElementVNode)("table", _hoisted_3, [
                        (0, vue_1.createVNode)(_component_PlanetaryTrack, {
                            type: "risingPlayer",
                            val: _ctx.tracks.venus,
                            rewards: _ctx.rewards.venus,
                            gameOptions: _ctx.gameOptions
                        }, null, 8, ["val", "rewards", "gameOptions"]),
                        (0, vue_1.createVNode)(_component_PlanetaryTrack, {
                            type: "everyone",
                            val: _ctx.tracks.venus,
                            rewards: _ctx.rewards.venus,
                            gameOptions: _ctx.gameOptions
                        }, null, 8, ["val", "rewards", "gameOptions"])
                    ])
                ]))
                : (0, vue_1.createCommentVNode)("", true),
            (0, vue_1.createElementVNode)("div", _hoisted_4, [
                _cache[1] || (_cache[1] = (0, vue_1.createElementVNode)("div", { class: "track-tag track-tag-earth" }, null, -1)),
                (0, vue_1.createElementVNode)("table", _hoisted_5, [
                    (0, vue_1.createVNode)(_component_PlanetaryTrack, {
                        type: "risingPlayer",
                        val: _ctx.tracks.earth,
                        rewards: _ctx.rewards.earth,
                        gameOptions: _ctx.gameOptions
                    }, null, 8, ["val", "rewards", "gameOptions"]),
                    (0, vue_1.createVNode)(_component_PlanetaryTrack, {
                        type: "everyone",
                        val: _ctx.tracks.earth,
                        rewards: _ctx.rewards.earth,
                        gameOptions: _ctx.gameOptions
                    }, null, 8, ["val", "rewards", "gameOptions"])
                ])
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_6, [
                _cache[2] || (_cache[2] = (0, vue_1.createElementVNode)("div", { class: "track-tag track-tag-mars" }, null, -1)),
                (0, vue_1.createElementVNode)("table", _hoisted_7, [
                    (0, vue_1.createVNode)(_component_PlanetaryTrack, {
                        type: "risingPlayer",
                        val: _ctx.tracks.mars,
                        rewards: _ctx.rewards.mars,
                        gameOptions: _ctx.gameOptions
                    }, null, 8, ["val", "rewards", "gameOptions"]),
                    (0, vue_1.createVNode)(_component_PlanetaryTrack, {
                        type: "everyone",
                        val: _ctx.tracks.mars,
                        rewards: _ctx.rewards.mars,
                        gameOptions: _ctx.gameOptions
                    }, null, 8, ["val", "rewards", "gameOptions"])
                ])
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_8, [
                _cache[3] || (_cache[3] = (0, vue_1.createElementVNode)("div", { class: "track-tag track-tag-jovian" }, null, -1)),
                (0, vue_1.createElementVNode)("table", _hoisted_9, [
                    (0, vue_1.createVNode)(_component_PlanetaryTrack, {
                        type: "risingPlayer",
                        val: _ctx.tracks.jovian,
                        rewards: _ctx.rewards.jovian,
                        gameOptions: _ctx.gameOptions
                    }, null, 8, ["val", "rewards", "gameOptions"]),
                    (0, vue_1.createVNode)(_component_PlanetaryTrack, {
                        type: "everyone",
                        val: _ctx.tracks.jovian,
                        rewards: _ctx.rewards.jovian,
                        gameOptions: _ctx.gameOptions
                    }, null, 8, ["val", "rewards", "gameOptions"])
                ])
            ]),
            (_ctx.tracks.moon >= 0)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_10, [
                    _cache[4] || (_cache[4] = (0, vue_1.createElementVNode)("div", { class: "track-tag track-tag-moon" }, null, -1)),
                    (0, vue_1.createElementVNode)("table", _hoisted_11, [
                        (0, vue_1.createVNode)(_component_PlanetaryTrack, {
                            type: "risingPlayer",
                            val: _ctx.tracks.moon,
                            rewards: _ctx.rewards.moon,
                            gameOptions: _ctx.gameOptions
                        }, null, 8, ["val", "rewards", "gameOptions"]),
                        (0, vue_1.createVNode)(_component_PlanetaryTrack, {
                            type: "everyone",
                            val: _ctx.tracks.moon,
                            rewards: _ctx.rewards.moon,
                            gameOptions: _ctx.gameOptions
                        }, null, 8, ["val", "rewards", "gameOptions"])
                    ])
                ]))
                : (0, vue_1.createCommentVNode)("", true)
        ]))
        : (0, vue_1.createCommentVNode)("", true);
}
